var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLimitededition = function SvgLimitededition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.001,
    height: 64
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10156",
    transform: "translate(-691 -626.335)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#ebebeb",
    "data-name": "Ellipse 760",
    transform: "translate(691 626.335)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4629",
    transform: "translate(736.438 671.772)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.282,
    cy: 9.282,
    r: 9.282,
    fill: "#ffc62d",
    "data-name": "Ellipse 686"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.729 3.276h13.1v13.1h-13.1Z",
    "data-name": "Path 4503"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.103 8.19h-2.184V4.914H7.643V8.19H5.459l3.822 3.824ZM8.735 9.282V6.006h1.092v3.276h.639l-1.185 1.185-1.185-1.185Zm-3.276 3.822h7.644v1.092H5.459Z",
    "data-name": "Path 4504"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "001-clover"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M734.873 650.761a9.3 9.3 0 0 0-4.481 1.552 9.3 9.3 0 0 0 1.552-4.481 3.92 3.92 0 0 0-4.051-4.108h-6.788a3.924 3.924 0 0 0-4.05 4.108 9.3 9.3 0 0 0 1.551 4.481 9.3 9.3 0 0 0-4.481-1.552 3.92 3.92 0 0 0-4.108 4.051v6.788a3.924 3.924 0 0 0 4.108 4.05 9.3 9.3 0 0 0 4.481-1.552 9.3 9.3 0 0 0-1.552 4.481 3.92 3.92 0 0 0 4.05 4.108h6.788a3.924 3.924 0 0 0 4.05-4.108 9.3 9.3 0 0 0-1.552-4.481 9.3 9.3 0 0 0 4.481 1.552 3.92 3.92 0 0 0 4.108-4.05v-6.788a3.924 3.924 0 0 0-4.106-4.051m-13.768-5.337h6.788a2.284 2.284 0 0 1 2.353 2.411c0 2.669-3.4 6.78-5.748 9.107-2.162-2.14-5.748-6.378-5.748-9.107a2.284 2.284 0 0 1 2.355-2.411m-9.388 16.176v-6.788a2.284 2.284 0 0 1 2.408-2.354c2.759 0 6.972 3.591 9.107 5.748-2.379 2.4-6.5 5.748-9.107 5.748a2.284 2.284 0 0 1-2.408-2.354m16.179 9.391h-6.791a2.284 2.284 0 0 1-2.353-2.411c0-2.765 3.6-6.985 5.748-9.107 2.606 2.58 5.748 6.589 5.748 9.107a2.284 2.284 0 0 1-2.355 2.411Zm9.391-9.391a2.284 2.284 0 0 1-2.411 2.353c-2.668 0-6.779-3.4-9.107-5.748 2.141-2.162 6.36-5.748 9.107-5.748a2.284 2.284 0 0 1 2.411 2.353Z",
    "data-name": "Path 4581"
  })))));
};
export { SvgLimitededition as ReactComponent };
export default "/_next/static/images/Limitededition.svg";